import React from 'react';
import { motion } from 'framer-motion';
import { LogOut, User } from 'lucide-react';
import { useAuthContext } from './AuthContext';
import { AuthModal } from './AuthModal';

export const UserMenu: React.FC = () => {
  const { user, logout } = useAuthContext();
  const [showAuthModal, setShowAuthModal] = React.useState(false);

  if (!user) {
    return (
      <>
        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => setShowAuthModal(true)}
          className="flex items-center gap-2 px-4 py-2 rounded-lg bg-orange-500 text-white hover:bg-orange-600 transition-colors"
        >
          <User size={20} />
          Iniciar sesión
        </motion.button>

        <AuthModal
          isOpen={showAuthModal}
          onClose={() => setShowAuthModal(false)}
        />
      </>
    );
  }

  return (
    <div className="relative group">
      <motion.button
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        className="flex items-center gap-2 px-4 py-2 rounded-lg bg-orange-50 hover:bg-orange-100 transition-colors"
      >
        <User size={20} className="text-orange-500" />
        <span className="text-gray-700">{user.email}</span>
      </motion.button>

      <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all">
        <motion.button
          whileHover={{ scale: 1.02 }}
          onClick={() => logout()}
          className="w-full flex items-center gap-2 px-4 py-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors"
        >
          <LogOut size={16} />
          Cerrar sesión
        </motion.button>
      </div>
    </div>
  );
};